import ALEX_STATES from './AlexStates';
import { SET_ALEX_STATE, SET_ALEX_ANIMATION } from './AlexActions';

const initialState = {
    alexState: ALEX_STATES.INACTIVE,
    isAnimationDisabled: false,
};

export default function(state = initialState, action) {
    switch (action.type) {
    case SET_ALEX_STATE:
        return {
            ...state,
            alexState: action.payload,
        };
    case SET_ALEX_ANIMATION:
        return {
            ...state,
            isAnimationDisabled: action.payload,
        };
    default:
        return state;
    }
}
